import { FC } from 'react';
import { useIntl } from 'react-intl';
import { createBemBlockBuilder, Error } from '@ebsco-ui/ebsco-ui';

import { sharedMessages } from '@app/translations';

import './ErrorBoundaryMessage.scss';

const cnBem = createBemBlockBuilder(['errorBoundaryMessage']);

export const ErrorBoundaryMessage: FC = () => {
  const { $t } = useIntl();

  return (
    <Error
      title={$t(sharedMessages.somethingWentWrong)}
      description={$t(sharedMessages.processingError)}
      className={cnBem()}
    />
  );
};
